import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-full-overlay',
	templateUrl: './full-overlay.component.html',
	styleUrls: ['./full-overlay.component.scss'],
})
export class FullOverlayComponent {
	/**
	 * Component constructor
	 * @param sanitizer - dom sanitizer
	 * @param dialogRef - mat dialog reference
	 * @param data - dialog input data
	 */
	constructor(
		private dialogRef: MatDialogRef<FullOverlayComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	/**
	 * On dialog close
	 */
	close(): void {
		this.dialogRef.close(true);
	}
}
